import React from 'react'

const Eventenquery = () => {
    return (
        <div>

        </div>
    )
}

export default Eventenquery
